import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OsmRoadsService from "../services/OsmRoadsService";

const useOsmRoadsService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OsmRoadsService(client);
  }, [client]);

  return service;
};

export default useOsmRoadsService;
